import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableHeadContainer, TableHeadItem } from '../../../../../../components/TableHead';
import { tableHeadWithdrawal } from '../../constants';

export const WithdrawalHeader: React.FC = () => {
  return (
    <TableHeadContainer px={Spacing['inline.xxxs']}>
      {tableHeadWithdrawal.map((item, index) => (
        <TableHeadItem key={`${item.title}-${index}`} {...item} value={item.orderValue} />
      ))}
    </TableHeadContainer>
  );
};
